import request from '@/utils/request'

export function getInvoiceList(data) {
  return request.post('/wxfwh/invoice-list', data)
}

export function addInvoice(data) {
  return request.post('/wxfwh/invoice-add', data)
}

export function modifyInvoiceStatus(data) {
  return request.post('/wxfwh/invoice-modify-status', data)
}



// WEBPACK FOOTER //
// ./src/api/invoice.js